<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title>
        <v-img
            :src="require('./assets/Header-Iottly-600x160.png')"
            class="my-3"
            contain
            width="200"
          ></v-img>            
      </v-toolbar-title>
      <span class="title text-uppercase" >       
        CLOUD VPN
      </span>      
      <div v-if="loggedIn">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
              <v-btn fab dark small @click="downloadClientCertificate" color="orange darken-4" v-on="on" style="margin-left:5px;">
                <v-icon dark>mdi-cloud-print-outline</v-icon> 
              </v-btn>
          </template>
          <span>Download client configuration</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
              <v-btn fab dark small @click="downloadClient" color="orange darken-4" v-on="on" style="margin-left:5px;">
                <v-icon dark>mdi-cloud-download</v-icon> 
              </v-btn>
          </template>
          <span>Download client installer</span>
        </v-tooltip> 
      </div>
      <v-spacer></v-spacer>                         
      <div v-if="loggedIn">        
        <span class="title text-uppercase" style="vertical-align: middle;">       
          {{ user.display_name }} 
        </span>
      <!--  <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn fab dark small @click="logout" color="orange darken-4" v-on="on" style="margin-left:5px;">
              <v-icon dark>mdi-key-variant</v-icon>             
            </v-btn>   
          </template>
          <span>Change password</span>
        </v-tooltip>-->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn fab dark small @click="logout" color="orange darken-4" v-on="on" style="margin-left:5px;">
              <v-icon dark>mdi-logout</v-icon>             
            </v-btn>   
          </template>
          <span>Logout</span>
        </v-tooltip>
      </div>
    </v-app-bar>

    <v-content>
     <router-view></router-view>
   
    </v-content>
    <v-snackbar v-model="show"
      :color="color"
      top
      right
      :timeout=3000
    >
      {{message}}    
      <v-btn dark text @click.native="show = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import VPNList from '@/components/VPNList';
import LoginPage from '@/components/login/LoginPage';
import { mapState } from 'vuex'
export default {
  name: 'App',
  components: {
    VPNList,
    LoginPage
  },
  computed: {
        ...mapState([
        'user',
        'loggedIn'
        ]),        
    },
  data () {
    return {
      show: false,
      message: '',
      color:''
    }
  },
  methods: {
        downloadClient() { 
          this.$store.dispatch('downloadClientFile');           
        },
        downloadClientCertificate() { 
          this.$store.dispatch('downloadClientCertificate');           
        },
        logout() {
          this.$store.dispatch('vpn_logout');
        }
    },
    created: function () {
      this.$store.watch(state => state.snackbar.text, () => {
        const msg = this.$store.state.snackbar.text
        if (msg !== '') {
          this.show = true
          this.message = this.$store.state.snackbar.text
          this.color = this.$store.state.snackbar.color
          setTimeout(() => { this.$store.dispatch('reset_snackbar');},this.timeout);
        }
    })
  }
  
};
</script>
